import { FormControlLabel, Radio, Typography } from "@material-ui/core"
import ReportReceivedParams from "components/DocumentReceivedReportParams/DocumentRecivedReportParams"
import { RECEIVED_REPORT_TYPES } from "lib"
import { TypeReportReceived } from "lib/enums/reportType.enum"
import { IDocumentReceivedReportParams } from "types"

interface Props {
  selected: TypeReportReceived[]
  toggleSelect: (TypeReportReceived: TypeReportReceived) => void
  onChange: (key: string, value: any) => void
  params: IDocumentReceivedReportParams
}

const ReportReceivedTypePicker = (props: Props) => {
  const { selected, toggleSelect, onChange, params } = props
  return (
    <div
      className="flex flex-grow flex-col h-full mr-4 bg-transparent"
      style={{ overflowY: "auto" }}
    >
      <Typography
        className="pb-3 pt-4"
        color="textSecondary"
        variant="body2"
        style={{ fontWeight: 700, letterSpacing: 0.5 }}
      >
        {"Reportes y parámetros"}
      </Typography>
      <div className="flex flex-grow flex-col">
        {RECEIVED_REPORT_TYPES.map((reportType) => (
          <div className="flex-grow my-1 pl-4">
            <FormControlLabel
              control={
                <Radio
                  checked={selected.includes(reportType.reportType)}
                  size="small"
                   onClick={() => toggleSelect(reportType.reportType)}
                />
              }
              label={
                <Typography variant="button" style={{ letterSpacing: 0.5 }}>
                  {reportType.name}
                </Typography>
              }
            />
            <ReportReceivedParams
              type={reportType.reportType}
              disabled={!selected.includes(reportType.reportType)}
              reportKey={reportType.key}
              params={params}
              onChange={onChange}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ReportReceivedTypePicker
